import { getEnumSelectList } from "@/utils/select-list";

const TagType = {
  Employer: 1
};

const tagTypeSelectList = getEnumSelectList(TagType);

export default TagType;
export { tagTypeSelectList };